import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import Slider from 'react-slick'
import { NextBtn, PreviousBtn } from '../../components/Buttons'
import { useAuth } from '../../context/ContextData'
import AlertMessage from '../../components/modals/AlertMessage'
import DealerConnectModal from '../../components/modals/DealerConnectModal'
import DemoModal from '../../components/modals/DemoModal'
import ShareModal from '../../components/modals/ShareModal'

const RelatedProducts = ({ data, priceData }) => {
    const [showShare, setShowShare] = useState(false);
    const [shareUrl, setShareUrl] = useState('');
    const [title, setTitle] = useState('');

    const hostname = document.location.origin;
    const navigate = useNavigate();
    // const [pages, setPage]= useState(1);
    // const dealerId = localStorage.getItem("dealerId")

    const [showToast, setShowToast] = useState(false);
    const [reqType, setReqType] = useState("");
    const [delaerShow, setDelaerShow] = useState(false);
    const [demoToast, setDemoToast] = useState(false);

    const { wished, setWished, removeWished, setRemoveWished, cart, setCart, removeCart, setRemoveCart, demo, dealerId } = useAuth()

    // ---------------------------Wished Items------------------------
    const localWished = JSON.parse(localStorage.getItem("wished"))
    useEffect(() => {
        if (localWished && wished.length === 0) {
            if (removeWished === 0) {
                localStorage.removeItem("wished")
            } else {
                setWished(...wished, localWished)
            }
        }
        if (wished.length !== 0) {
            localStorage.setItem("wished", JSON.stringify(wished))
        }

    }, [wished, setWished, localWished, removeWished,])

    // ---------------------------Cart Items------------------------
    const localCart = JSON.parse(localStorage.getItem("cart"))
    useEffect(() => {
        if (localCart && cart.length === 0) {
            if (removeCart === 0) {
                localStorage.removeItem("cart")
            } else {
                setCart(...cart, localCart)
            }
        }
        if (cart.length !== 0) {
            localStorage.setItem("cart", JSON.stringify(cart))
        }

    }, [cart, setCart, localCart, removeCart,])

    // const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)
    // const myRef = useRef(null)

    // const onPageChanged = useCallback(
    //     (event, page) => {
    //         event.preventDefault();
    //         setPage(page);
    //         scrollToRef(myRef)
    //     },
    //     [setPage]
    // );

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <React.Fragment>
            <ShareModal
                show={showShare}
                setShowShare={() => setShowShare(false)}
                url={shareUrl}
                title={title}
            />
            <DealerConnectModal
                show={delaerShow}
                setShow={setDelaerShow}
            />
            <AlertMessage
                show={showToast}
                setShow={() => setShowToast(false)}
                reqType={reqType}
            />
            <DemoModal
                show={demoToast}
                setShow={setDemoToast}
            />

            <div className="wm">
                <h1 className="text-center mt-5">RELATED PRODUCTS</h1>
                <Slider
                    prevArrow={<PreviousBtn />}
                    nextArrow={<NextBtn />}
                    // centerMode={true}
                    // centerPadding={'30px 0px 0px 0px'}
                    className="mb-3 border-0"
                    {...settings}
                >
                    {data && data.map((item, index) =>
                        <div key={index} className="px-2">
                            <Link to={'/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo + (dealerId && "?dealerId=" + dealerId)}>
                                <img src={process.env.REACT_APP_S3URL + item.masterimg} alt={item.alt} className="w-100" />
                            </Link>
                            <Row className="mx-0 ">
                                <Col xxl={9} xs={8} className="ps-0 cp">
                                    <Link to={'/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo}>
                                        <p className="mp_text_length mb-0">
                                            {item.title}
                                        </p>
                                        {item.price && <h6 className="cpm">&#8377; {item.price}/{item.unit} </h6>}
                                    </Link>
                                </Col>
                                <Col xxl={3} xs={4} className="text-end pe-0">
                                    <div className="justify-content-end d-flex">
                                        <img src="/assets/icons/share.png" alt="bg" className="mouse mpswb mt-2" onClick={() => { setShowShare(true); setTitle(item.title); setShareUrl(hostname + '/productdetails/' + (item.title && item.title.replace(/[\s,-;]+/g, "-").toLowerCase()) + "/" + item.itemNo + (dealerId && "?dealerId=" + dealerId)) }} />
                                        {/* <img src={item.wished === 'yes' ? "/assets/icons/wished.png" : "/assets/icons/wish.svg"} alt="bg" className={`mouse mpswb mx-2 mt-2 `} />
                                        <img src="/assets/icons/bag.svg" alt="bg" className="mouse mpswb mt-2" /> */}
                                        <img src={
                                            wished.find(obj => obj.itemNo === item.itemNo)
                                                ? "/assets/icons/wished.png" : "/assets/icons/wish.svg"}
                                            alt="wish"
                                            className={`mouse mpswb mx-2 mt-2 `}
                                            onClick={() => {
                                                if (demo) {
                                                    setDemoToast(true)
                                                }
                                                else if (!dealerId) {
                                                    setDelaerShow(true)
                                                }
                                                else if (wished.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (wished.length === 1) {
                                                        setRemoveWished(0)
                                                        setReqType("removeWished")
                                                    }
                                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === item.itemNo))
                                                    wished.splice(x, 1)
                                                    setWished([...wished])
                                                    setReqType("removeWished")
                                                }
                                                else if (cart.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (cart.length === 1) {
                                                        setRemoveCart(0)
                                                        setWished([...wished, item])
                                                        setReqType("moveWished")
                                                        setShowToast(true)
                                                    }
                                                    const x = cart.indexOf(cart.find(obj => obj.itemNo === item.itemNo))
                                                    cart.splice(x, 1)
                                                    setCart([...cart])
                                                    setWished([...wished, item])
                                                    setReqType("moveWished")
                                                    setShowToast(true)
                                                }
                                                else {
                                                    setWished([...wished, item])
                                                    setReqType("addWished")
                                                    setShowToast(true)
                                                }
                                            }} />

                                        <img
                                            src={cart.find(obj => obj.itemNo === item.itemNo) ? "/assets/icons/bagGreen.svg" : "/assets/icons/bag.svg"}
                                            alt="cart"
                                            className="mouse mpswb mt-2"
                                            onClick={() => {
                                                if (demo) {
                                                    setDemoToast(true)
                                                }
                                                else if (!dealerId) {
                                                    setDelaerShow(true)
                                                }
                                                else if (cart.find(obj => obj.itemNo === item.itemNo)) {
                                                    navigate("/checkout/cart")
                                                }
                                                else if (wished.find(obj => obj.itemNo === item.itemNo)) {
                                                    if (wished.length === 1) {
                                                        setRemoveWished(0)
                                                        setCart([...cart, item])
                                                        setReqType("moveCart")
                                                        setShowToast(true)
                                                    }
                                                    const x = wished.indexOf(wished.find(obj => obj.itemNo === item.itemNo))
                                                    wished.splice(x, 1)
                                                    setWished([...wished])
                                                    setCart([...cart, item])
                                                    setReqType("moveCart")
                                                    setShowToast(true)
                                                }
                                                else {
                                                    setCart([...cart, item])
                                                    setReqType("addCart")
                                                    setShowToast(true)
                                                }
                                            }} />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Slider>
            </div>
        </React.Fragment>
    )
}

export default RelatedProducts
